import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useActiveSession } from "../../utils/sessionGuard";

const hasGrantForPath = (pageList, path) => {
  const authority = (pageList || []).find((item) => item.path === path);
  return authority ? authority.read === 1 : false;
};

const ProtectedRoute = ({ element, ...rest }) => {
  const location = useLocation();

  const { isCheckingSession, userId } = useActiveSession({
    loadAuthorities: true
  });
  const userData = useSelector((state) => state.userData.userData);

  if (isCheckingSession) return null;

  if (!userId) {
    return (
      <Navigate to="/unauthorized" replace state={{ from: location.pathname }} />
    );
  }

  return hasGrantForPath(userData?.pageList, rest.path) ? (
    element
  ) : (
    <Navigate to="/unauthorized" replace state={{ from: location.pathname }} />
  );
};

export default ProtectedRoute;
